import { callApi } from '@/api/api-core'

export const calculatePrice = function(tripId, passengers, ownerHandlesFailure) {
	return callApi(
		'POST',
		'v1/products/dsb/price/calculate',
		{
			tripId,
			passengers
		},
		ownerHandlesFailure
	)
}
